var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326",
    transform: "translate(-5829 -3342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M5844.488,3351.1h-3.821a.6.6,0,1,1,0-1.2h3.821a.6.6,0,1,1,0,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M5836.474,3351.706a.6.6,0,0,1-.423-.175l-1.065-1.065a.6.6,0,0,1,.846-.847l.642.642,1.374-1.374a.6.6,0,1,1,.846.847l-1.8,1.8a.6.6,0,0,1-.424.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M5844.488,3356.69h-3.821a.6.6,0,1,1,0-1.2h3.821a.6.6,0,1,1,0,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M5836.474,3357.3a.593.593,0,0,1-.423-.175l-1.065-1.065a.6.6,0,0,1,.846-.847l.642.642,1.374-1.374a.6.6,0,1,1,.846.847l-1.8,1.8a.6.6,0,0,1-.424.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M5842.4,3361.585H5837.6c-4.336,0-6.189-1.853-6.189-6.189V3350.6c0-4.336,1.853-6.189,6.189-6.189h4.792c4.336,0,6.189,1.853,6.189,6.189v4.792C5848.585,3359.732,5846.732,3361.585,5842.4,3361.585Zm-4.792-15.972c-3.681,0-4.991,1.31-4.991,4.991v4.792c0,3.681,1.31,4.991,4.991,4.991h4.792c3.681,0,4.991-1.31,4.991-4.991V3350.6c0-3.681-1.31-4.991-4.991-4.991Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 22,
    height: 22,
    transform: "translate(5829 3342)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjects);
export default __webpack_public_path__ + "static/media/icon-projects.57e830ade53365f8553117a985b991ec.svg";
export { ForwardRef as ReactComponent };